import { TbEyeSearch } from "react-icons/tb";
import { useEffect, useState } from "react";
import { getData } from "src/actions/getData";
import PageHeader from "src/components/PageHeader";
import Table from "src/components/Table";
import FilterColumn from "src/components/Table/FilterColumn";
import { FilterFn } from "src/components/Table/FilterFn";
import moment from 'jalali-moment';
import Modal from "src/components/Modal";
import ModalHeader from "src/components/Modal/ModalHeader";
import ModalBody from "src/components/Modal/ModalBody";
import ModalFooter from "src/components/Modal/ModalFooter";
import TwinButton from "src/components/TwinButton";
import JsonFormatter from "react-json-formatter";
import isJson from "src/utils/isJson";
import MiniInfoButton from "src/components/MiniInfoButton";


const jsonStyle = {
    propertyStyle: { color: 'green' },
    stringStyle: { color: 'gray' },
    numberStyle: { color: 'brown' }
}
export default function Logs() {
    const [logs, setLogs] = useState()
    const [rowData, setRowData] = useState()
    const [isModalOpen, setIsModalOpen] = useState(false)
    useEffect(() => {
        getData(setLogs, "/logs")

    }, [])
    const columns = [
        {
            id: "correlationId",
            cell: (info) => info.getValue(),
            header: "شناسه",
        },
        {
            id: "method",
            cell: (info) => info.getValue(),
            header: "نوع درخواست",
        },
        {
            id: "endpoint",
            cell: (info) => info.getValue(),
            header: "مسیر درخواست",
        },
        {
            id: "statusCode",
            cell: (info) => <MiniInfoButton
                text={info.getValue()}
                textColor={parseInt(info.getValue()) >= 200 && parseInt(info.getValue()) < 400 ? "green" : parseInt(info.getValue()) >= 400 && parseInt(info.getValue()) < 500 ? "red" : "orange"}
                backgroundColor={parseInt(info.getValue()) >= 200 && parseInt(info.getValue()) < 400 ? "#20965a1a" : parseInt(info.getValue()) >= 400 && parseInt(info.getValue()) < 500 ? "#c01c1d1a" : "#ffa5001a"}
            />,
            header: "وضعیت پاسخ",
        },
        {
            id: "responseTimeMs",
            cell: (info) => info.getValue(),
            header: "مدت زمان پاسخ (ms)",
        },
        {
            id: "ipAddress",
            cell: (info) => info.getValue() == "195.28.168.91" ? "وبسایت" : info.getValue(),
            header: "IP درخواست دهنده",
        },
        {
            id: "userAgent",
            cell: (info) => info.getValue(),
            header: "userAgent درخواست دهنده",
        },
        {
            id: "fullName",
            cell: (info) => info.getValue() ? info.getValue() : "کاربر ناشناس",
            header: "کاربر",
        },
        {
            id: "createdAt",
            cell: (info) => (
                <>
                    {info.getValue()
                        ? moment
                            .from(info.getValue())
                            .locale("fa")
                            .format("jYYYY/jMM/jDD HH:mm")
                        : "---"}
                </>
            ),
            FilterFn: (row, columnId, filterValue) => {
                // type can be "object" , "array" , "string" , "number"
                return FilterFn(row, columnId, filterValue, "date");
            },
            meta: {
                filterComponent: (setFilterValue) => {
                    return <FilterColumn setFilterValue={setFilterValue} type="date" />;
                },
            },
            header: "تاریخ",
        },
        {
            id: "id",
            cell: (info) => (
                <div className="flex gap-2">
                    <div
                        className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 bg-gray-50 dark:bg-gray-900 dark:hover:bg-gray-700 text-gray-400 p-2 rounded-lg"
                        onClick={() => {
                            setRowData(info.row.original)
                            setIsModalOpen(true)
                        }}
                    >
                        <TbEyeSearch className="text-blue-500" />
                    </div>
                </div>
            ),
            header: "عملیات",
            footer: (info) => info.column.id,
            enableColumnFilter: false,
        }
    ];

    return (
        <>
            <PageHeader
                title="لاگ سیستم"
            />
            <Table data={logs} columns={columns} />


            <Modal isOpen={isModalOpen} toggle={setIsModalOpen}>
                <ModalHeader>جزئیات درخواست</ModalHeader>
                <ModalBody>
                    <div className="p-5 flex flex-col gap-2">
                        <span>درخواست</span>
                        <div className="bg-gray-50 p-4 rounded-xl" style={{ direction: "ltr" }}>
                            {
                                isJson(rowData?.requestBody)
                                    ?
                                    <JsonFormatter json={rowData?.requestBody} jsonStyle={jsonStyle} />
                                    :
                                    <div className="overflow-hidden">
                                        {rowData?.requestBody}
                                    </div>
                            }
                        </div>
                        <span>پاسخ</span>
                        <div className="bg-gray-50 p-4 rounded-xl" style={{ direction: "ltr" }}>
                            {
                                isJson(rowData?.responseBody)
                                    ?
                                    <JsonFormatter json={rowData?.responseBody} jsonStyle={jsonStyle} />
                                    :
                                    <div className="overflow-hidden">
                                        {rowData?.responseBody}
                                    </div>
                            }
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <TwinButton
                        acceptTitle={false}
                        rejectHandle={() => { setIsModalOpen(false) }}
                        rejectTitle="بستن"
                        isCompact={true}
                    />
                </ModalFooter>
            </Modal>
        </>

    )
}
